import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from '../common/WhatsAppButton';
import TikTokPixel from '../common/TikTokPixel';
import GoogleAnalytics from '../common/GoogleAnalytics';
import FacebookPixel from '../common/FacebookPixel';
import BackgroundTasks from '../common/BackgroundTasks';
import GlobalConsentBanner from '../common/GlobalConsentBanner';

const Layout = ({ handleClickWhatsApp }) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.language?.startsWith('ar');

  return (
    <>
      <GoogleAnalytics />
      <FacebookPixel />
      <TikTokPixel />
      <div className="flex flex-col min-h-screen bg-brand-bg-body text-brand-text-main transition-colors duration-300" dir={isRtl ? 'rtl' : 'ltr'}>
        <Header />
        <main className="flex-grow pt-24 lg:pt-28">
          <Outlet />
        </main>
        <WhatsAppButton />
        <BackgroundTasks />
        <GlobalConsentBanner />
        <Footer handleClickWhatsApp={handleClickWhatsApp} />
      </div>
    </>
  );
};

export default Layout;
